import { config } from '@/config'

import { tokenResponseSchema } from './email-pass-auth'

export const exchangeToken = async (exchangeToken: string) => {
  const result = await fetch(`${config.services.api}/core/login/exchange`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      exchangeToken,
    }),
  })

  if (result.ok) {
    return tokenResponseSchema.parse(await result.json())
  }

  return null
}
